import * as yup from "yup";

export const emailValidationSchema = yup.object({
  email: yup.string().trim().email("L'email doit être valide !").required("Veuillez saisir l'adresse mail"),
  fullname: yup.string().trim().required("Veuillez saisir le nom complet"),
  message: yup.string().trim().required("Veuillez saisir le message"),
});
